export const getUser = state => state.user
export const getStagedUser = state => getUser(state).stagedRecord
export const getUserRecords = state => getUser(state).records
export const getUserUIFlags = state => getUser(state).uiFlags
